import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["condition", "inputUse", "isRollingDateOffsetInputEnabled", "onChange"];
import FilterOperatorRollingDateRangeInput from './FilterOperatorRollingDateRangeInput';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { memo } from 'react';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UINumberInput from 'UIComponents/input/UINumberInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterOperatorRollingDateInput = props => {
  const {
      condition,
      inputUse,
      isRollingDateOffsetInputEnabled,
      onChange
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FilterOperatorRollingDateRangeInput, Object.assign({
      condition: condition,
      onChange: onChange
    }, rest)), isRollingDateOffsetInputEnabled && /*#__PURE__*/_jsx(UIFormControl, {
      className: "p-all-0",
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.customerDataFilters.FilterOperatorRollingDateInput.offsetLabel"
      }),
      children: /*#__PURE__*/_jsx(UINumberInput, {
        onChange: evt => {
          const {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'value' does not exist on type 'EventTarg... Remove this comment to see the full error message
            target: {
              value: newRollingOffset
            }
          } = evt;
          onChange(syntheticEvent(condition.set('rollingOffset', newRollingOffset)));
        },
        placeholder: 0,
        use: inputUse,
        value: condition.rollingOffset
      })
    })]
  });
};
export default /*#__PURE__*/memo(FilterOperatorRollingDateInput);